import FedexLogo from "../assets/images/home/fedex-logo.png"
import AdpLogo from "../assets/images/home/adp-logo.png"
import GustoLogo from "../assets/images/home/gusto-logo.png"
import PaychexLogo from "../assets/images/home/paychex-logo.png"
import MailChimpLogo from "../assets/images/home/mailChimp-logo.png"
import QuickBooksLogo from "../assets/images/home/quickBooks-logo.png"
import CompaniesIconBig from "../assets/images/insights/companies-icon-big.png"

import DashboardIcon from "../assets/images/sidebar/element-3.svg"
import LeaderboardIcon from "../assets/images/sidebar/ranking.svg"
import EmployeeIcon from "../assets/images/sidebar/profile-2user.svg"
import ScheduleIcon from "../assets/images/sidebar/calendar-2.svg"
import WriteUpIcon from "../assets/images/sidebar/note.svg"
import PayrollIcon from "../assets/images/sidebar/dollar-square.svg"
import ExpenseIcon from "../assets/images/sidebar/card-pos.svg"
import HelpIcon from "../assets/images/sidebar/book.svg"
import IntegrationIcon from "../assets/images/sidebar/convertshape-2.svg"
import SettingsIcon from "../assets/images/sidebar/setting-2.svg"


// export const LOCAL_STORAGE_KEYS = {
//   ACCESS_TOKEN: "access_token",
//   AUTHORIZATION_TOKEN: "authorization_token"
// }

export const insightsItems = [
  {
    name: "Dashboard",
    icon: DashboardIcon,
    url: "/"
  },
  {
    name: "Leaderboard",
    icon: LeaderboardIcon,
    url: "/leaderboard",
    permission: 'leaderboard.view'
  },
]

export const teamItems = [
  {
    name: "Employees",
    icon: EmployeeIcon,
    url: "/employees",
    permission: 'employee.view'

  },
  {
    name: "Schedule",
    icon: ScheduleIcon,
    url: "/schedule",
    permission: 'schedule.view',
    beta: true
  },
  {
    name: "Write-Ups",
    icon: WriteUpIcon,
    url: "/employee-write-up",
    permission: 'writeup.view'
  },
]

export const payrollItems = [
  {
    name: "Payroll",
    icon: PayrollIcon,
    url: "/run-payroll",
    permission: 'payroll.view'
  },
  {
    name: "Expenses",
    icon: ExpenseIcon,
    url: "/expenses",
    permission: 'expenses.view'

  }
]

export const supportItems = [
  {
    name: "Help Center",
    icon: HelpIcon,
    url: "http://fleetwage.com/help",
    redirect: true,
    permission: 'helpcenter.view'

  }
]

export const adminItems = [
  {
    name: "Integrations",
    icon: IntegrationIcon,
    url: "/app",
    permission: 'integration.view'
  },
  // {
  //   name: 'Training',
  //   icon: OtherChartBig,
  //   url: '/app'
  // },
  // {
  //   name: 'Handbook',
  //   icon: BookBig,
  //   url: '/app'
  // },
  {
    name: "Settings",
    icon: SettingsIcon,
    url: "/settings",
  }
]

export const companyIcons = {
  fedex: FedexLogo,
  adp: AdpLogo,
  gusto: GustoLogo,
  paychex: PaychexLogo,
  mailChimp: MailChimpLogo,
  quickBooks: QuickBooksLogo
}


export const insightsTableArray = [
  {
    id: 1,
    name: "Zev Express Inc",
    stations: 2,
    revenue: "43,612.59",
    logo: CompaniesIconBig
  },
  {
    id: 2,
    name: "Urartu Logistics Inc",
    stations: 4,
    revenue: "60,200.35",
    logo: CompaniesIconBig
  },
  {
    id: 3,
    name: "Main Line Logistics Inc",
    stations: 3,
    revenue: "72,211.42",
    logo: CompaniesIconBig
  },
  {
    id: 4,
    name: "Next Mile Inc",
    stations: 1,
    revenue: "17,042.64",
    logo: CompaniesIconBig
  }
]

export const userRoles = {
  SUPER_ADMIN: "superadmin",
  ORGANIZATION_ADMIN: "organization_admin",
  ADMIN: "admin",
  MEMBER: "guest"
}
